export default function Navbar() {
  return (
    <nav className="bg-white border-b border-gray-100 sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-8">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 flex items-center justify-center">
                <i className="ri-plane-line text-3xl text-teal-600"></i>
              </div>
              <span className="text-xl font-bold text-gray-900">USATravelGuide</span>
            </div>
            
            <div className="hidden md:flex items-center gap-6">
              <a href="/" className="text-sm text-gray-600 hover:text-teal-600 font-medium transition-colors">
                Trang chủ
              </a>
              <a href="/visa-travel-tips" className="text-sm text-teal-600 font-medium">
                Visa & Tips
              </a>
              <a href="#" className="text-sm text-gray-600 hover:text-teal-600 font-medium transition-colors">
                Tour du lịch
              </a>
              <a href="#" className="text-sm text-gray-600 hover:text-teal-600 font-medium transition-colors">
                Liên hệ
              </a>
            </div>
          </div>

          <div className="flex items-center gap-4">
            <button className="bg-teal-600 text-white px-6 py-2 rounded-lg text-sm font-medium hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer">
              Tư vấn miễn phí
            </button>
            
            <button className="md:hidden p-2 rounded-lg text-gray-500 hover:text-gray-700 hover:bg-gray-100">
              <i className="ri-menu-line text-xl"></i>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}